import React from "react";
import { Link } from "react-router-dom";
import { FaCoins } from "react-icons/fa";
import { ACCENT_GRADIENT, CONTROL } from "./ui";

/**
 * The customer's credit balance in the header — a pill that doubles as the way
 * to top up. Zero balance turns the amount red, since it blocks every patch.
 */
const CreditBalanceBadge = ({ balance }) => {
    const empty = !balance || Number(balance) === 0;

    return (
        <Link
            to={"/buy-credits"}
            title="Click to buy Credits"
            className={`flex h-10 items-center gap-2 rounded-full border pl-3 pr-1.5 transition hover:border-red-400/60 ${CONTROL}`}
        >
            <FaCoins className={`h-4 w-4 ${empty ? "text-rose-500" : "text-red-500 dark:text-orange-400"}`} />
            <span className="hidden text-xs font-medium text-gray-500 dark:text-slate-400 sm:block">
                Credits
            </span>
            <span
                className={`rounded-full px-2.5 py-1 text-xs font-bold text-white ${
                    empty ? "bg-rose-500" : ACCENT_GRADIENT
                }`}
            >
                {Number(balance || 0).toFixed(2)}
            </span>
        </Link>
    );
};

export default CreditBalanceBadge;
